export const NOT_SET_PLACEHOLDER = "nezadáno";
